import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center min-h-screen"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center min-h-screen"
}
const _hoisted_4 = { class: "text-center max-w-md px-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8 h-8 text-red-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
    })
  ])
], -1)
const _hoisted_6 = { class: "text-2xl font-bold text-gray-900 mb-2" }
const _hoisted_7 = { class: "text-gray-600 mb-6" }
const _hoisted_8 = {
  key: 2,
  class: "max-w-7xl mx-auto"
}
const _hoisted_9 = { class: "relative bg-gradient-to-r from-blue-600 to-purple-700 text-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black opacity-20" }, null, -1)
const _hoisted_11 = { class: "relative px-6 py-16 sm:py-24" }
const _hoisted_12 = { class: "max-w-3xl" }
const _hoisted_13 = { class: "text-4xl sm:text-5xl font-bold mb-4" }
const _hoisted_14 = {
  key: 0,
  class: "text-xl sm:text-2xl mb-8 opacity-90"
}
const _hoisted_15 = { class: "px-6 py-12" }
const _hoisted_16 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-12" }
const _hoisted_17 = { class: "lg:col-span-2" }
const _hoisted_18 = { class: "mb-12" }
const _hoisted_19 = { class: "text-3xl font-bold text-gray-900 mb-6" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 0,
  class: "mb-12"
}
const _hoisted_22 = { class: "text-3xl font-bold text-gray-900 mb-6" }
const _hoisted_23 = { class: "space-y-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_25 = { class: "text-gray-700" }
const _hoisted_26 = {
  key: 1,
  class: "mb-12"
}
const _hoisted_27 = { class: "text-3xl font-bold text-gray-900 mb-6" }
const _hoisted_28 = { class: "space-y-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "•", -1)
const _hoisted_30 = {
  key: 2,
  class: "mb-12"
}
const _hoisted_31 = { class: "text-3xl font-bold text-gray-900 mb-6" }
const _hoisted_32 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 p-6" }
const _hoisted_33 = { class: "space-y-3" }
const _hoisted_34 = { class: "w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-sm font-semibold mr-4" }
const _hoisted_35 = { class: "text-gray-800" }
const _hoisted_36 = { class: "lg:col-span-1" }
const _hoisted_37 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8" }
const _hoisted_38 = { class: "text-xl font-bold text-gray-900 mb-4" }
const _hoisted_39 = { class: "space-y-4" }
const _hoisted_40 = { class: "flex justify-between" }
const _hoisted_41 = { class: "text-gray-600" }
const _hoisted_42 = { class: "font-semibold" }
const _hoisted_43 = { class: "flex justify-between" }
const _hoisted_44 = { class: "text-gray-600" }
const _hoisted_45 = { class: "font-semibold" }
const _hoisted_46 = { class: "flex justify-between" }
const _hoisted_47 = { class: "text-gray-600" }
const _hoisted_48 = { class: "font-semibold" }
const _hoisted_49 = { class: "sticky top-6" }
const _hoisted_50 = { class: "text-center text-sm text-gray-500 mt-2" }

import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getPublicCourseData, enrollInPublicCourse } from "@/api/courses";
import { getTranslatedString as _ } from "@/i18n";
import type { PublicCourseData } from "@/models/interfaces";
import Spinner from "@/components/ui/Spinner.vue";
import Btn from "@/components/ui/Btn.vue";
import { useMetaStore } from "@/stores/metaStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicCourseLanding',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const metaStore = useMetaStore();

const courseData = ref<PublicCourseData | null>(null);
const loading = ref(true);
const error = ref<string | null>(null);
const enrolling = ref(false);

const slug = route.params.slug as string;

const loadCourseData = async () => {
	loading.value = true;
	error.value = null;

	try {
		courseData.value = await getPublicCourseData(slug);
	} catch (err: any) {
		console.error("Failed to load course data:", err);
		error.value = err.response?.data?.detail || _("course_landing.not_found_message");
	} finally {
		loading.value = false;
	}
};

onMounted(loadCourseData);

const handleEnrollment = async () => {
	if (!courseData.value) return;

	enrolling.value = true;
	try {
		if (!metaStore.isAuthenticated) {
			// Redirect to login with enrollment redirect
			const redirectPath = `/c/${slug}/journey`;
			router.push({
				name: "Login",
				query: {
					redirect: redirectPath,
					enroll: slug,
				},
			});
			return;
		}

		// User is authenticated, enroll directly
		await enrollInPublicCourse(slug, `/c/${slug}/journey`);

		// Redirect to course journey
		router.push(`/c/${slug}/journey`);
	} catch (err: any) {
		console.error("Enrollment failed:", err);

		// Show user-friendly error message
		const errorMessage =
			err.response?.data?.detail || _("course_landing.enrollment_failed");
		alert(errorMessage); // In a real app, you'd use a proper notification system
	} finally {
		enrolling.value = false;
	}
};

const retryLoading = () => {
	loadCourseData();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Spinner, {
            size: "xl",
            variant: "primary"
          })
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("course_landing.not_found_title")), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(error.value), 1),
              _createElementVNode("button", {
                onClick: retryLoading,
                class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              }, _toDisplayString(_ctx.$t("course_landing.try_again")), 1)
            ])
          ]))
        : (courseData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h1", _hoisted_13, _toDisplayString(courseData.value.course.name), 1),
                    (courseData.value.course.public_metadata?.short_description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(courseData.value.course.public_metadata?.short_description), 1))
                      : _createCommentVNode("", true),
                    _createVNode(Btn, {
                      loading: enrolling.value,
                      onClick: handleEnrollment,
                      variant: "secondary",
                      class: "px-8 py-3 text-lg font-semibold bg-white text-blue-600 hover:bg-gray-100"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("course_landing.start_learning")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("section", _hoisted_18, [
                      _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t("course_landing.about_title")), 1),
                      _createElementVNode("div", {
                        class: "prose prose-lg max-w-none",
                        innerHTML: courseData.value.course.description
                      }, null, 8, _hoisted_20)
                    ]),
                    (courseData.value.course.public_metadata?.learning_outcomes?.length)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                          _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.$t("course_landing.what_youll_learn")), 1),
                          _createElementVNode("ul", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseData.value.course.public_metadata.learning_outcomes, (outcome) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: outcome,
                                class: "flex items-start"
                              }, [
                                _hoisted_24,
                                _createElementVNode("span", _hoisted_25, _toDisplayString(outcome), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (courseData.value.course.public_metadata?.prerequisites?.length)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
                          _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t("course_landing.prerequisites")), 1),
                          _createElementVNode("ul", _hoisted_28, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseData.value.course.public_metadata.prerequisites, (prereq) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: prereq,
                                class: "flex items-start text-gray-700"
                              }, [
                                _hoisted_29,
                                _createTextVNode(" " + _toDisplayString(prereq), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (courseData.value.preview_content?.syllabus_outline?.length)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
                          _createElementVNode("h2", _hoisted_31, _toDisplayString(_ctx.$t("course_landing.course_content")), 1),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("ul", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseData.value.preview_content.syllabus_outline, (topic, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: index,
                                  class: "flex items-center"
                                }, [
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(index + 1), 1),
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(topic), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.$t("course_landing.course_stats")), 1),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("course_landing.total_lessons")), 1),
                          _createElementVNode("span", _hoisted_42, _toDisplayString(courseData.value.stats.total_lessons), 1)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("course_landing.completion_rate")), 1),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(Math.round(courseData.value.stats.average_completion_rate * 100)) + "%", 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("course_landing.students_enrolled")), 1),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(courseData.value.stats.total_enrollments.toLocaleString()), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(Btn, {
                        loading: enrolling.value,
                        onClick: handleEnrollment,
                        variant: "primary",
                        class: "w-full px-6 py-3 text-lg font-semibold"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("course_landing.enroll_free")), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("course_landing.join_students", {
										count: courseData.value.stats.total_enrollments.toLocaleString(),
									})), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})